import 'moment/min/locales';

export function formatTimeWithUserLocale(momentTime) {
  const timeCopy = momentTime.clone();
  const browserLocale = require('browser-locale')();
  timeCopy.locale(browserLocale);
  return timeCopy.format('LT');
}
